(function ReportUpcomingDepartures($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReportUpcomingDepartures',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		Adzuki.Typeahead(
			'.departure-port-search',
			function search(term, display, $self)
			{
				var uri = '/Reports/departureTypeaheadSearch/' + term;

				Adzuki.Ajax.get(uri)
					.then(function searchDisplay(response)
					{
						$self.removeClass('ajax-spinner');
						display(response);
					})
					.catch(function searchError()
					{
						$self.removeClass('ajax-spinner');
						display([{name: "Error searching for departure ports."}]);
					}
				);
			},
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
			},
			function template(item) {
				var html = item.name;
				return html;
			}
		);
	};


}(jQuery, window.Adzuki || {}));